var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBtnExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7197 6.63033C11.0126 6.92322 11.4874 6.92322 11.7803 6.63033C12.0732 6.33744 12.0732 5.86256 11.7803 5.56967L8.43033 2.21967C8.13744 1.92678 7.66256 1.92678 7.36967 2.21967L4.01967 5.56967C3.72678 5.86256 3.72678 6.33744 4.01967 6.63033C4.31256 6.92322 4.78744 6.92322 5.08033 6.63033L7.14941 4.56125L7.14941 10.5107C7.14941 10.925 7.4852 11.2607 7.89941 11.2607C8.31363 11.2607 8.64941 10.925 8.64941 10.5107V4.56007L10.7197 6.63033Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10V14H13V10",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBtnExport);
export default __webpack_public_path__ + "static/media/icn_btn_export.3103e323e2f31dc3faaf89952141ea53.svg";
export { ForwardRef as ReactComponent };